export { default as Avatar } from './avatar'
export type { Props as AvatarProps } from './avatar'
